import { useTranslation } from "react-i18next";

import { Stepper } from "@aviary";
import { useIsFullscriptOnly } from "@shared/hooks/useIsFullscriptOnly/useIsFullscriptOnly";
import { l } from "@unauthenticated/shared/locales/i18n";

import * as styles from "./PractitionerSignupStepper.styles";

type Props = {
  size?: "small" | "large";
  currentStep: number;
  hidden?: boolean;
  hideLabels?: boolean;
};

const PractitionerSignupStepper = ({
  size = "small",
  currentStep,
  hidden = false,
  hideLabels = false,
}: Props) => {
  const { t } = useTranslation();

  const isFullscriptOnly = useIsFullscriptOnly();

  const steps = [
    { label: t(l.common.practitionerSignupStepper.step1) },
    { label: t(l.common.practitionerSignupStepper.step2) },
    { label: t(l.common.practitionerSignupStepper.step3) },
    ...(isFullscriptOnly ? [{ label: t(l.common.practitionerSignupStepper.step4) }] : []),
  ];

  return (
    <div css={styles.stepper} hidden={hidden}>
      <Stepper
        size={size}
        isDashed
        isIncompleteFinalStep
        currentStep={currentStep}
        steps={hideLabels ? steps.length : steps}
      />
    </div>
  );
};

export default PractitionerSignupStepper;
